import { createListenerMiddleware } from '@reduxjs/toolkit';
import { baseApi } from '@/shared/api/baseApi';
import { sessionCleared } from '@/shared/lib/redux/actions';

/** Signing out invalidates every RTK Query cache entry — otherwise a screen could briefly render
 *  stale data after a new session starts. */
export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: sessionCleared,
  effect: (_action, api) => {
    api.dispatch(baseApi.util.resetApiState());
  },
});
